import React from 'react';
import { XCircle } from 'lucide-react';
export function WhyItFailed() {
  const reasons = [{
    title: "Las dietas americanas como la 'Keto'",
    description: 'Son insostenibles porque le obligan a dejar los alimentos que han sido parte de nuestra cultura por siglos.'
  }, {
    title: 'Los suplementos de farmacia',
    description: 'Suelen ser versiones sintéticas que su cuerpo de 55+ ya no absorbe bien.'
  }, {
    title: 'Contar calorías',
    description: 'Es una tortura que no funciona si no se corrige primero la inflamación celular.'
  }, {
    title: 'Los consejos genéricos',
    description: 'Ignoran que nuestro metabolismo a esta edad requiere un orden específico de nutrientes, no una restricción total.'
  }];
  return <section className="py-20 bg-white" data-id="element-254">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-255">
        <div className="max-w-5xl mx-auto" data-id="element-256">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16" data-id="element-257">
            Por qué nada de lo que ha probado funciona
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-258">
            {reasons.map((reason, index) => <div key={index} className="bg-red-50/50 border border-red-100 rounded-2xl p-6 md:p-8 flex items-start gap-4 hover:shadow-md transition-shadow" data-id="element-259">
                <XCircle className="w-8 h-8 text-red-500 shrink-0 mt-1" data-id="element-260" />
                <div data-id="element-261">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-262">
                    {reason.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-263">
                    {reason.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}